import { ChangeEvent, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MenuItem, TextField } from '@mui/material';

import { changeSharedVideoFormPrivacy } from 'main/store/videos/actions';
import { selectSharedVideoPrivacy } from 'main/store/videos/selectors';
import { Privacy } from 'main/store/videos/state';

const HELPER_TEXT = {
    public: '誰でも参照可能',
    private: 'メンバーのみ参照可能'
}

export const PrivacySelect = () => {
    const dispatch = useDispatch();
    const value = useSelector(selectSharedVideoPrivacy);

    const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
        const privacy = event.target.value as Privacy;
        dispatch(changeSharedVideoFormPrivacy(privacy));
    }, [dispatch]);

    return (
        <TextField
            fullWidth
            select
            label="プライバシー"
            value={value}
            onChange={handleChange}
            helperText={HELPER_TEXT[value]}
        >
            <MenuItem value="public">公開</MenuItem>
            <MenuItem value="private">非公開</MenuItem>
        </TextField>
    )
}
